import SyncVuex from "@/plugins/syncVuex";
import { navigation } from "@/store/modules/navigation";
import { patient } from "@/store/modules/patient";
import { tower } from "@/store/modules/tower";
import { user } from "@/store/modules/user";
import { RootState } from "@/store/types";
import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";

const debug = process.env.NODE_ENV !== "production";

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    version: "1.0.0"
  },
  modules: {
    user,
    patient,
    navigation,
    tower
  },
  plugins: [SyncVuex],
  actions: {
    resetAll({ commit }) {
      commit("patient/reset");
      commit("user/reset");
    }
  },
  strict: debug
};

const vuexStore = new Vuex.Store<RootState>(store);
vuexStore.subscribe(mediator);
export default vuexStore;

function mediator({ type }: { type: string }) {
  switch (type) {
    case "noop":
      return;
  }
}
